import { lazy } from 'react';

const CharityDonationCertificateRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityDonationCertificate" */ '../components/steps/donation-certificate-step/DonationCertificate'
    ),
);

export default CharityDonationCertificateRoute;
